import {useTranslation} from 'react-i18next'
import {Hint} from '@/components/ui/hint'
import {PorQue} from '@/components/ui/por-que'
import {InviteLink} from '@/components/invite-link'
import type {AccessGrant} from '@/hooks/platform/use-access'

/** Outcome of «Dar acceso»: an invite or an already-active notice, never a password field. */
export function AccessResult({grant}: {grant: AccessGrant}) {
  const {t} = useTranslation()
  if (grant.access === 'por_verificar') {
    return (
      <p className="notice-amber rounded-lg px-3 py-2 text-sm font-medium" data-testid="access-por-verificar">
        {t('access.porVerificar')}
      </p>
    )
  }
  if (grant.access === 'already_active') {
    return (
      <p className="text-sm font-medium text-primary" data-testid="access-already-active">
        {t('access.alreadyActive')}
      </p>
    )
  }
  // Sin token ni correo no hubo entrega: no se afirma «Invitación enviada.».
  if (!grant.invite_token && !grant.employee.email) {
    return (
      <div className="notice-amber space-y-1.5 rounded-lg px-3 py-2" data-testid="access-invited">
        <p className="text-sm font-medium" data-testid="access-invited-no-channel">
          {t('access.invitedNoChannel')}
        </p>
        <PorQue
          label={t('access.invitedNoChannelLabel')}
          testId="access-no-channel-porque"
          contenidoTestId="access-no-channel-detalle">
          {t('access.invitedNoChannelPorQue')}
        </PorQue>
      </div>
    )
  }
  return (
    <div className="space-y-3" data-testid="access-invited">
      <p className="text-sm font-medium text-primary">{t('access.invited')}</p>
      {grant.invite_token ? (
        <div className="space-y-2 rounded-lg border border-border bg-secondary/40 p-3">
          <Hint>{t('access.invitedHint')}</Hint>
          <InviteLink token={grant.invite_token} kind="invite" />
        </div>
      ) : (
        <Hint testId="access-invited-email">{t('access.invitedEmailSent', {email: grant.employee.email})}</Hint>
      )}
    </div>
  )
}
